export default "__VITE_ASSET__BLXHvXJe__"